// Everything about the Kinesin PCRS Client browser extension lives in this
// feature, so it can move with whichever screen does PCRS checks.

export const PCRS_EXTENSION_NAME = "Kinesin PCRS Client";

export const PCRS_EXTENSION_ID = process.env.REACT_APP_PCRS_EXTENSION_ID;

// Unlisted listing — this link is the only way to reach it.
export const PCRS_EXTENSION_STORE_URL = `https://chromewebstore.google.com/detail/${PCRS_EXTENSION_ID}`;
